<template>
    <!-- 包装一个 input，让它支持数据双向绑定 v-model，同时也支持 form 表单的效验 -->
    <div class="custom-input">
        <h1>sdfsdfsdf</h1>
        <!-- 使用一个输入框 -->
        <a-input :placeholder="otherParam" v-model="localValue.field1"></a-input>
        <a-input :placeholder="otherParam" v-model="localValue.field2"></a-input>
        <h1>{{localValue.filed1}}</h1>
    </div>
</template>

<script>
    import mixin from '../mixin/AExtObjMixin'
    export default {
        mixins:[mixin],
        props: {
            otherParam:{
                type:String
            }
        },
        data () {
            return {
                //属性需要填全
                localValue: {field1:'',field2:''}
            }
        },
        methods: {

        }
    }
</script>
